import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row mt-2" }
const _hoisted_2 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0" }
const _hoisted_3 = {
  for: "bc_amount",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_4 = { class: "col-sm-12" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { class: "row mt-2" }
const _hoisted_7 = { class: "col-sm-12 d-flex justify-content-between align-items-center pb-0" }
const _hoisted_8 = {
  for: "bc_comment",
  class: "col-form-label text-capitalize-first"
}
const _hoisted_9 = { class: "col-sm-12" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputWrapper = _resolveComponent("FormInputWrapper")!
  const _component_LoaderWrapper = _resolveComponent("LoaderWrapper")!
  const _component_b_modal = _resolveComponent("b-modal")!

  return (_openBlock(), _createBlock(_component_b_modal, {
    title: _ctx.modalTitle,
    modelValue: _ctx.showModal,
    "body-class": "pt-0",
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('update:showModal', $event)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", null, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("label", _hoisted_3, _toDisplayString(_ctx.helper.trans('labels.amount')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.balanceErrors.amount
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  disabled: _ctx.isSubmitting,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.balanceForm.amount) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  type: "text",
                  id: "bc_amount",
                  onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAmountInput && _ctx.handleAmountInput(...args)))
                }, null, 42, _hoisted_5), [
                  [_vModelText, _ctx.balanceForm.amount]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.helper.trans('labels.comment')), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_FormInputWrapper, {
              errors: _ctx.balanceErrors.comment
            }, {
              default: _withCtx((parentProps) => [
                _withDirectives(_createElementVNode("input", {
                  disabled: _ctx.isSubmitting,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.balanceForm.comment) = $event)),
                  class: _normalizeClass([parentProps.class, "form-control"]),
                  type: "text",
                  id: "bc_comment",
                  onInput: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleCommentInput && _ctx.handleCommentInput(...args)))
                }, null, 42, _hoisted_10), [
                  [_vModelText, _ctx.balanceForm.comment]
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        disabled: _ctx.isSubmitting,
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:showModal', false))),
        class: "btn btn-outline-secondary btn-sm text-capitalize-first"
      }, _toDisplayString(_ctx.helper.trans('button.cancel')), 9, _hoisted_11),
      _createVNode(_component_LoaderWrapper, {
        ref: "loaderBalanceCorrection",
        zoom: 0.5
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            type: "button",
            disabled: !_ctx.isBalanceFormValid || _ctx.isSubmitting,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.submitBalanceCorrection && _ctx.submitBalanceCorrection(...args))),
            class: "btn btn-outline-primary btn-sm text-capitalize-first"
          }, _toDisplayString(_ctx.helper.trans('button.confirm')), 9, _hoisted_12)
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["title", "modelValue"]))
}